import React from "react";
import { useSelector, useDispatch } from "react-redux";

import _ from "lodash";

import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Divider,
  IconButton,
  Fab,
} from "@material-ui/core";

import SnackBar from "../../layouts/SnackBar";
import CCValidation from "../../components/Checkin/Verify/CCValidation";
import TwoStepsVerify from "../../components/Checkin/Verify/TwoStepsVerify";

import * as checkinActions from "src/actions/checkinActions";

import { ThemeProvider } from "react-jss";
import moment from "moment";

import { theme } from "../../components/ui/theme";

import getBrandFromUrl from "../../utils/getBrandFromUrl";
import CloseIcon from "@material-ui/icons/Close";
import {apiURI} from "../../env";
import getCountryFromURL from "src/utils/getCountryFromUrl";

const CheckinVerify = () => {
  const dispatch = useDispatch();
  const checkin = useSelector((state) => state.checkin);
  const isDemo = useSelector((state) => state.checkin.isDemo);

  const [willExpire, setWillExpire] = React.useState(false);
  const [letSessionExpire, setLetSessionExpire] = React.useState(false);
  const [sessionTracker, setSessionTracker] = React.useState(null);
  const isAdditionalDriver = checkin.isAdditionalDriver;

  const reservationNumber = React.useMemo(() => {
    return checkin.resNo;
  }, [checkin.resNo]);

  const randomNumber = React.useMemo(() => {
    return Math.random();
  }, [checkin.resNo]);

  React.useEffect(() => {
    setLetSessionExpire(false);
    clearInterval(sessionTracker);
    setSessionTracker(
      setInterval(() => {
        const sessionExpiry = _.get(checkin, "auth.expires", moment().subtract(0, "m").unix());
        if (moment().isAfter(moment.unix(sessionExpiry))) {
          window.location.replace(`/${isDemo? 'checkin-demo':'checkin'}/login`);
        }
        const isExpiring = moment().add(2, "m").isAfter(moment.unix(sessionExpiry));
        setWillExpire(isExpiring);
      }, 10000)
    );
    setWillExpire(false);
  }, [checkin.auth.expires]);

  const onExtendSession = () => {
    dispatch(checkinActions.extendSession());
  };

  return (
    <div>
      <SnackBar />
      <ThemeProvider theme={theme}>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          style={{ marginTop: 20 }}
        >
          <Grid item>
            <TwoStepsVerify />
          </Grid>
        </Grid>
      </ThemeProvider>

      <Dialog open={willExpire && !letSessionExpire}>
        <DialogTitle style={{ textAlign: "center" }}>
          <IconButton aria-label="close" onClick={() => setLetSessionExpire(true)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>Your session will expire in 1 minute.</DialogContent>
        <DialogActions>
          <Divider />
          <Grid spacing={1} container direction="row" justify="center">
            <Grid container item xs={12} justify="center">
              <Fab color="primary" variant="extended" onClick={onExtendSession}>
                Extend My Session
              </Fab>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      {reservationNumber != "" && (
        <img
          src={`${apiURI}/pixel/${window.location.pathname.replace(/\//g,'_')}.png?b=${reservationNumber}&a=${"verify"}&country=${getCountryFromURL()}&c=${randomNumber}&brand=${getBrandFromUrl()}&t=${isAdditionalDriver? "additional_driver":"primary_driver"}`}
          style={{ display: "none" }}
        />
      )}
    </div>
  );
};

export default CheckinVerify;
